export const CHANGE_STATE = 'CHANGE_STATE'
export const SHIFT_MONTH='SHIFT_MONTH'
export const CHANGE_WINDOW='CHANGE_WINDOW'
export const GET_LESSONS = 'GET_LESSONS'
export const SET_MONTH='SET_MONTH'
export const BUILD_NCCD='BUILD_NCCD'
export const CLEANUP_NCCD='CLEANUP_NCCD'
export const SETUP_EXAM = 'SETUP_EXAM'
export const SETUP_EMAIL='SETUP_EMAIL'
